import { forwardRef } from 'react';
import BaseIconStyled from '../style';

const PlusIcon = forwardRef(({ children, color, variant, ...props }, ref) => {
  return (
    <BaseIconStyled {...props} color={color}>
      <g clipPath="url(#clip0_198_2604)">
        <path d="M12 -0.0294195L12 11.9706M12 23.9706L12 11.9706M12 11.9706L24 11.9706M12 11.9706L-1.18289e-06 11.9706" />
      </g>
      <defs>
        <clipPath id="clip0_198_2604">
          <rect width="24" height="24" fill="white" transform="translate(24) rotate(90)" />
        </clipPath>
      </defs>
    </BaseIconStyled>
  );
});

export default PlusIcon;
